import { Link, useRouterState } from "@tanstack/react-router";
import { useMe } from "@/app/session";

/** Навигация шапки (S1–S4): разделы будущих подпроектов ведут на пустые состояния, не 404. */
export const NAV = [
  { to: "/", label: "маршрут" },
  { to: "/map", label: "карта треков" },
  { to: "/practice", label: "доп. практика" },
  { to: "/homework", label: "домашки" },
  { to: "/notebooks", label: "ноутбуки" },
  { to: "/questions", label: "банк вопросов" },
] as const;

/** Разделы ментора и админа (SP4): очередь проверки. */
export const STAFF_NAV = [
  { to: "/mentor/queue", label: "очередь" },
  { to: "/mentor/cohort/all", label: "когорта" },
] as const;

/** Разделы админа и владельца (SP5): люди и аналитика. */
export const ADMIN_NAV = [
  { to: "/admin/people", label: "люди" },
  { to: "/admin/analytics", label: "аналитика" },
] as const;

const STAFF = new Set(["mentor", "admin", "owner"]);
const ADMIN = new Set(["admin", "owner"]);

export function TopNav() {
  const path = useRouterState({ select: (s) => s.location.pathname });
  const me = useMe();
  const role = me.data?.role ?? "";
  const items: readonly { to: string; label: string }[] = [...NAV, ...(STAFF.has(role) ? STAFF_NAV : []), ...(ADMIN.has(role) ? ADMIN_NAV : [])];
  return (
    <nav aria-label="разделы" className="hidden items-center gap-1 md:flex">
      {items.map((n) => {
        const active = n.to === "/" ? path === "/" || path.startsWith("/track") || path.startsWith("/step") : path.startsWith(n.to);
        return (
          <Link key={n.to} to={n.to} className={`rounded-sm px-2.5 py-1.5 font-mono text-[11.5px] no-underline ${active ? "bg-accsoft text-acc" : "text-mut hover:text-ink"}`}>
            {n.label}
          </Link>
        );
      })}
    </nav>
  );
}

/** Инициалы для аватара: «Анна Ковалёва» → «АК». */
export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? "")
    .join("");
}

export function Avatar({ name }: { name: string }) {
  return (
    <span aria-hidden className="grid size-[26px] place-items-center rounded-full border border-bd2 bg-accsoft font-mono text-[11px] font-semibold text-acc">
      {initials(name)}
    </span>
  );
}
